module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setting",
    attrs: {
      "id": "Setting"
    }
  }, [_c('div', {
    staticClass: "headImg"
  }, [_c('img', {
    attrs: {
      "src": _vm.headImg
    }
  })]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "label": "昵称",
      "disabled": ""
    },
    model: {
      value: (_vm.nickname),
      callback: function($$v) {
        _vm.nickname = $$v
      },
      expression: "nickname"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "姓名",
      "disabled": ""
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "性别",
      "disabled": ""
    },
    on: {
      "click": function($event) {
        return _vm.choiceSex()
      }
    },
    model: {
      value: (_vm.sex),
      callback: function($$v) {
        _vm.sex = $$v
      },
      expression: "sex"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "手机号码",
      "placeholder": "请输入手机号",
      "disabled": ""
    },
    model: {
      value: (_vm.telephone),
      callback: function($$v) {
        _vm.telephone = $$v
      },
      expression: "telephone"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "地区",
      "placeholder": "请选择地址",
      "disabled": ""
    },
    on: {
      "click": function($event) {
        return _vm.choiceAdd()
      }
    },
    model: {
      value: (_vm.region),
      callback: function($$v) {
        _vm.region = $$v
      },
      expression: "region"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "disabled": "",
      "label": "详细地址",
      "type": "textarea",
      "rows": "1",
      "autosize": ""
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = $$v
      },
      expression: "address"
    }
  })], 1), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.areaList,
      "value": _vm.adrCode,
      "title": "选择地址"
    },
    on: {
      "confirm": _vm.addadr,
      "cancel": _vm.cancel
    }
  })], 1), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.show2),
      callback: function($$v) {
        _vm.show2 = $$v
      },
      expression: "show2"
    }
  }, [_c('van-radio', {
    attrs: {
      "name": "男"
    },
    model: {
      value: (_vm.sex),
      callback: function($$v) {
        _vm.sex = $$v
      },
      expression: "sex"
    }
  }, [_vm._v("男")]), _c('br'), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "女"
    },
    model: {
      value: (_vm.sex),
      callback: function($$v) {
        _vm.sex = $$v
      },
      expression: "sex"
    }
  }, [_vm._v("女")]), _c('br'), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "保密"
    },
    model: {
      value: (_vm.sex),
      callback: function($$v) {
        _vm.sex = $$v
      },
      expression: "sex"
    }
  }, [_vm._v("保密")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/shake"
    }
  }, [_c('p', [_c('br')])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a30bd5b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/Setting.vue
// module id = 432
// module chunks = 0